// import { Document } from '../administration/document/document.models';

import { FilterInfo, SortInfo } from "../../global/interfaces";

export const DOCUMENTS_TABS = [
  'strategic-research',
  'client-documents',
  'product-documents',
  'mercer-insight-community',
];

export const DOCUMENTS_TYPE = {
  'strategic-research': 0,
  'client-documents': 1,
  'product-documents': 2,
  'mercer-insight-community': 3,
};

export interface DocumentsFilter {
  type: string;
  from: string;
  to: string;
}

export interface Document {
  _id: string;
  title?: string;
  type?: string;
  subtype?: string;
  filename?: string;
  originalName?: string;
  client?: string;
  account?: string;
  fund?: string;
  owner?: string;
  date?: string;
  status?: string;
  fundLength?: number;
  multiFund?: boolean;
}

export interface DocumentFileDownloadRequest {
  id: string;
  originalName: string;
}

export interface DocumentZipFileDownloadRequest {
  name?: string;
  filter?: FilterInfo;
  sort?: SortInfo;
  [key: string]: any;
  country?: string;
  accountName?: string;
  accountNumber?: number;
}

export interface LoadDocumentsResponse {
  total: number;
  data: Document[];
}
